import React from 'react';
import { withRouter, Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import logoutAction from '../../../actions/auth.actions/logout.action';
import fullLogoImg from '../../../template/utils/images/GroupB.png';

/**
 * @class UserDashBoardSideNavigation
 */
class UserDashBoardSideNavigation extends React.Component {
  /**
   * @description handle user log out
   *
   * @param {Object} event logout event object
   *
   *
   * @returns {undefined} calls logoutProps
   */
  onLogout = (event) => {
    const { logoutUser } = this.props;
    const { history } = this.props;
    event.preventDefault();
    logoutUser(history.push('/'));
  }

  removeInvestLink = () => {
    Cookie.remove('investLink');
  }

  removeActionType = () => {
    Cookie.remove('actionType');
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    return (
      <div className="side_nav">
        <div className="site_title">
          <div className="ml-2">
            <img src={fullLogoImg} alt="logoImg" style={{ height: '100px', width: '200px' }} />
          </div>


        </div>
        <div className="nav_menu">
          <div className="navigation_title_text">
            <p>
              NAVIGATION
            </p>
          </div>
          <NavLink
            exact
            to="/user-dashboard"
            activeClassName="active"
          >
            <i className="fas fa-tachometer-alt" />
            {' '}
&nbsp;
            Dashboard
          </NavLink>
          <NavLink
            exact
            to="/savings"
            activeClassName="active"
          >
            <i className="fas fa-piggy-bank" />
            {'    '}
            &nbsp;&nbsp;
            Savings
          </NavLink>
          <NavLink
            exact
            to="/invest-plans"
            activeClassName="active"
            onClick={this.removeInvestLink}
          >
            <i className="fas fa-hand-holding-usd" />
            &nbsp;&nbsp;
            Investment
          </NavLink>
          <NavLink
            exact
            to="/mutual-fund"
            activeClassName="active"
          > 
            <i className="fas fa-align-right" />
            {' '}
&nbsp;
            Mutual Funds
          </NavLink>
          <div className="help_title_text">
            <p id="quickLinks">
        Account Set Up
            </p>
          </div>
          <ul className="list-unstyled components">
            <li>
              <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                <span>
                  <i className="fa fa-cog" />
                  &nbsp;
                  Settings
                  {' '}

                </span>
              </a>
              <ul className="collapse list-unstyled" id="homeSubmenu">
                <li>
                  {' '} 
                  <NavLink
                    exact
                    to="/verify-bank-details"
                    style={{ fontSize: '14px' }}
                    activeClassName="active"
                  >
                    Add Bank Details
                  </NavLink>
                  {' '}
                </li>
                <li>
                  {' '}
                  <NavLink
                    exact
                    to="/add-card"
                    style={{ fontSize: '14px' }}
                    activeClassName="active"
                    onClick={this.removeActionType}
                  >
                      Add Card Details
                  </NavLink>
                  {' '}
                </li>
                <li>
                  {' '}
                  <NavLink
                    exact
                    activeClassName="active"
                    to="/verify-bvn"
                    style={{ fontSize: '14px' }}
                  >
                      BVN Verification
                  </NavLink>
                  {' '}
                </li>
                <li>
                  {' '}
                  <NavLink
                    exact
                    to="/know-your-customer"
                    style={{ fontSize: '14px' }}
                    activeClassName="active"
                  >
                    Set Up KYC
                  </NavLink>
                  {' '}
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="side_nav_logout">
          <Link
            onClick={this.onLogout}
            to="#"
          >
            <i className="fas fa-power-off" />
              Logout
          </Link>
        </div>

      </div>
    );
  }
}

UserDashBoardSideNavigation.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  match: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  logoutUser: () => dispatch(logoutAction()),
});

export default withRouter(connect(null,
  mapDispatchToProps)(UserDashBoardSideNavigation));
